module.exports = __webpack_public_path__ + "img/s.a655dcaf.jpg";